import React from "react";
import { Link } from "react-router-dom";
import { styles } from "./style.ts";

const Links = () => (
  <>
    <h2 style={{ ...styles.green, margin: "40px 10px 20px" }}>Follow Us?</h2>
    <div style={{ display: "inline-block" }}>
      <Link
        style={{ ...styles.socialSprite, ...styles.google }}
        to="//plus.google.com/113793509967046696175/about"
        target="_blank"
      />
      <Link
        style={{ ...styles.socialSprite, ...styles.twitter }}
        to="//twitter.com/quirkycoders"
        target="_blank"
      />
      <Link
        style={{ ...styles.socialSprite, ...styles.facebook }}
        to="//www.facebook.com/quirkycoders"
        target="_blank"
      />
      <Link
        style={{ ...styles.socialSprite, ...styles.rss }}
        to="/#"
        target="_blank"
      />
    </div>
  </>
);

export default Links;
